import cssVariables from 'tfs.css-variables'

export default {
  backDrop: {
    zIndex: 100,
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    backgroundColor: 'rgba(0,0,0,.7)',
  },

  wrapper: {
    position: 'relative',
    padding: '2rem',
    borderRadius: '5px',
    backgroundColor: cssVariables.colorWhite,
  },

  closeButton: {
    position: 'absolute',
    top: '1rem',
    right: '1rem',

    cursor: 'pointer',
    fontSize: '2rem',
    color: cssVariables.colorRuby,
    border: 'none',
    backgroundColor: 'transparent',
    transition: `${cssVariables.paceFast} ${cssVariables.easeIn} color`,

    '&:hover, &:focus': {
      color: cssVariables.colorRubyHover,
      outline: 'none',
    },
  },
}
